module.exports = __webpack_public_path__ + "img/itx-file-type-png.05c662bf.svg";